"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=600;exports.INPUT_DELAY=e;
